const Domain = window.globalConfig.baseUrl;
export default {
   Domain,
   validateMiriToken: `${Domain}${"/api/Miri/ValidateMiriToken"}`
}